import { render, staticRenderFns } from "./Splash.vue?vue&type=template&id=6b61a2ac&scoped=true&"
import script from "./Splash.vue?vue&type=script&lang=js&"
export * from "./Splash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b61a2ac",
  null
  
)

export default component.exports